import Naluri from '~/common/api/naluri';
import {
  PROGRESS_GET_WAISTLINES_BEGIN,
  PROGRESS_GET_WAISTLINES_SUCCESS,
  PROGRESS_GET_WAISTLINES_FAILURE,
  PROGRESS_GET_WAISTLINES_DISMISS_ERROR,
} from './constants';

export function getWaistlines(userId) {
  return dispatch => {
    dispatch({
      type: PROGRESS_GET_WAISTLINES_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
      const doRequest = Naluri.get(`/api/expert/waistlines?user_id=${userId}`);
      doRequest.then(
        res => {
          dispatch({
            type: PROGRESS_GET_WAISTLINES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        err => {
          dispatch({
            type: PROGRESS_GET_WAISTLINES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetWeighingsError() {
  return {
    type: PROGRESS_GET_WAISTLINES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROGRESS_GET_WAISTLINES_BEGIN:
      return {
        ...state,
        getWaistlinesPending: true,
        getWaistlinesError: null,
      };

    case PROGRESS_GET_WAISTLINES_SUCCESS:
      // The request is success
      return {
        ...state,
        waistlines: action.data,
        getWaistlinesPending: false,
        getWaistlinesError: null,
      };

    case PROGRESS_GET_WAISTLINES_FAILURE:
      // The request is failed
      return {
        ...state,
        getWaistlinesPending: false,
        getWaistlinesError: action.data.error,
      };

    case PROGRESS_GET_WAISTLINES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getWaistlinesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/progress/redux/getWaistlines.js